// 由 EB view/admin/src/router/modules/service.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const serviceRouter: RouteRecordRaw =
  {
    path: `${roterPre}/service`,
    name: 'service',
    meta: {
      icon: '',
      title: '公告列表'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'settings',
        name: 'serviceSettings',
        meta: {
          title: '服务设置'
        },
        component: () => import('@/views/service/settings/index.vue')
      },
      /* purchase — views 未迁移，暂不注册 */
        // {
        //     path: 'purchase',
        //     name: 'purchaseRecord',
        //     meta: {
        //         title: '购买记录'
        //     },
        //     component: () => import('@/views/service/purchase/index')
        // },
      {
        path: 'balance_record',
        name: 'balanceRecord',
        meta: {
          title: '店铺结余记录'
        },
        component: () => import('@/views/service/balanceRecord/index.vue')
      },
      {
        path: 'customer/list',
        name: 'customerList',
        meta: {
          title: '客服管理'
        },
        component: () => import('@/views/service/customer/index.vue')
      }
    ]
  }

export default serviceRouter;
